<template lang="pug">
  v-flex.pl-5.override-flex()
    li.tooltipContainer
      v-checkbox.mt-0.pt-2.pb-1(
          label="Autoriser le déplacement de la carte"
          hide-details :color="color"
        :input-value="this.config.map.dragging"
        @change="(value) => { changeComportements(value, 'dragging') }"
      )
      .spacer
      i.far.fa-question-circle.align-self-center.tooltip
        .bottom Les modifications liées au déplacement de la carte ne sont pas visibles sur cette interface, mais seront visibles sur le site.
    li.tooltipContainer
      v-checkbox.mt-0.pt-2.pb-1(
        label="Autoriser le zoom de la carte"
        hide-details :color="color"
        :input-value="this.config.map.scrollWheelZoom"
        @change="(value) => { changeComportements(value?1:0, 'scrollWheelZoom') }"
      )
      .spacer
      i.far.fa-question-circle.align-self-center.tooltip
        .bottom Les modifications liées au zoom ne sont pas visibles sur cette interface, mais seront visibles sur le site.
    li.tooltipContainer
      v-radio-group.mt-0(
        data-test="zoomModeChoice"
        @change="(value) => { changeComportements(value, 'scrollWheelZoom') }"
        :value="this.config.map.scrollWheelZoom"
        ref="colorModeChoice"
        :disabled='this.config.map.scrollWheelZoom === 0'
        hide-details
      )
        v-radio.ml-4.pa-2(
          label="Ctrl + Molette (⌘ + Molette)"
          :value="1"
          :color="color"
          data-test="controlMouseRadio"
        )
        v-radio.ml-4.mb-2.pl-2(
          label="Molette uniquement"
          :value="2"
          :color="color"
          data-test="mouseRadio"
        )
    li.tooltipContainer
      .info-zoom.ml-4.pl-2.mt-3 L'option 'Ctrl + Molette' permet à l'utilisateur de continuer à faire défiler la page qu'il consulte, sans être dérangé par la carte.
</template>

<script>
import RcColorPicker from '@/components/RcColorPicker.vue';
import mixin from '@/mixins/Rc.mixin.vue';

export default {
  props: {
    config: Object,
  },
  mixins: [mixin],
  components: {
    RcColorPicker,
  },
  data() {
    return {
      zoomValue: ['Désactivé', 'Ctrl + Molette', 'Molette'],
      zoomTypes: 2,
    };
  },
  watch: {
    config() {
      this.transientParams = this.filterConfig(this.config);
    },
  },
  mounted() {
    // console.log(this.config.map.scrollWheelZoom);
    this.zoomTypes = this.config.map.scrollWheelZoom;
  },
  methods: {
    changeComportements(value, type) {
      this.loading = true;
      this.config.map[type] = value;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
      this.$emit('removeMap', 'removed');
    },
  },
  computed: {
    categories() {
      return this.$store.state.layers.categories;
    },
    isChoice() {
      return this.$route.query.context === 'choice';
    },
    color() {
      return this.isChoice ? '#e75239' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
  .space-container{
    width: 300px;
    margin: 5px 20px;
  }
  .titreTerrain{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
    font-size: 15px;
  }
  .info-zoom{
    font-family: Roboto,sans-serif;
    font-style: italic;
    color: #A1A1A1;
    margin-bottom: 14px;
  }
  .tooltipContainer{
      display: grid;
      grid-template-columns: fit-content(100%) 14px 14px 1fr;
  }
  .tooltip {
    display:inline-block;
    position:relative;
    text-align:left;
    color: rgba(0,0,0,.54);
    top: 1.5px;
  }
  .tooltip .bottom{
    min-width: 290px;
    padding: 10px 15px;
    top: 40px;
    left: 50%;
    position: absolute;
    z-index: 99999;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    color: #a1a1a1;
    background-color: #eee;
    -webkit-box-shadow: 0 1px 8px rgb(0 0 0 / 50%);
    box-shadow: 0 1px 8px rgb(0 0 0 / 50%);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 8px;
    font-weight: normal;
    font-size: 13px;
    font-family: Roboto,sans-serif;
    display: none;
  }
  .tooltip:hover .bottom{
    display:block;
  }
</style>
